module.exports = __webpack_public_path__ + "static/media/add.93931a48.png";